import React, { useEffect, useState } from "react";
import "./HomeDashboard.scss";
import SummaryBarTile from "../../Components/DashboardTiles/SummaryBarTile";
import SummaryValueTile from "../../Components/DashboardTiles/SummaryValueTile";
import CategoryOverviewTile from "../../Components/DashboardTiles/CategoryOverviewTile";
import ComparisonBarTile from "../../Components/DashboardTiles/ComparisonBarTile";
import TrendsLineTile from "../../Components/DashboardTiles/TrendsLinetile";
import SalesEfficiencyTile from "../../Components/DashboardTiles/SalesEfficiencyTile";
import Banner from "../../Assets/img/home-dashboard/Frame2.png"

const HomeDashboard = () => {
    // Example data
    const [salesChanges, setSalesChanges] = useState([]);
    const [salesTrendData, setSalesTrendData] = useState([]);
    const [categoryData, setCategoryData] = useState([]);
    const [revenueData, setRevenueData] = useState([]);
    const [trendData, setTrendData] = useState([]);
    const [efficiencyData, setEfficiencyData] = useState([]);

    useEffect(() => {
        // Simulate fetching API data
        setSalesChanges([
            { month: "Jan", value: 60, amount: 58.32, change: "+8%" },
            { month: "Feb", value: 35, amount: 62.45, change: "+4%" },
            { month: "Mar", value: 50, amount: 64.89, change: "+3%" },
            { month: "Apr", value: 95, amount: 69.77, change: "+11%" },
            { month: "May", value: 60, amount: 63.21, change: "-3%" },
            { month: "Jun", value: 65, amount: 67.12, change: "+6%" },
        ]);

        setTrendData([
            { month: "Jan", value: 540000 },
            { month: "Feb", value: 580000 },
            { month: "Mar", value: 610000 },
            { month: "Apr", value: 590000 },
            { month: "May", value: 620000 },
            { month: "Jun", value: 630000 },
        ]);

        setCategoryData([
            { name: "Traditional Colas", value: 20 },
            { name: "Diet Options", value: 15 },
            { name: "Flavored", value: 45 },
            { name: "Energy Drinks", value: 10 },
            { name: "Sparkling Water", value: 5 },
            { name: "Other Beverages", value: 5 },
        ]);

        setRevenueData([
            { name: "WM", current: 60, previous: 50 },
            { name: "TGT", current: 40, previous: 38 },
            { name: "SFW", current: 30, previous: 25 },
            { name: "KLM", current: 15, previous: 18 },
        ]);

        setSalesTrendData([
            { month: "Jan", thisYear: 60, lastYear: 45 },
            { month: "Feb", thisYear: 78, lastYear: 52 },
            { month: "Mar", thisYear: 69, lastYear: 56 },
            { month: "Apr", thisYear: 90, lastYear: 66 },
            { month: "May", thisYear: 82, lastYear: 59 },
            { month: "Jun", thisYear: 74, lastYear: 62 },
            { month: "Jul", thisYear: 80, lastYear: 64 },
            { month: "Aug", thisYear: 72, lastYear: 60 },
            { month: "Sep", thisYear: 68, lastYear: 55 },
        ]);

        setEfficiencyData([
            { name: "Colas", distribution: 90, sales: 85, volume: 120 },
            { name: "Diet Options", distribution: 80, sales: 60, volume: 90 },
            { name: "Flavored", distribution: 60, sales: 75, volume: 100 },
            { name: "Energy Drinks", distribution: 70, sales: 50, volume: 70 },
            { name: "Water", distribution: 50, sales: 40, volume: 60 },
            { name: "Others", distribution: 30, sales: 25, volume: 40 },
        ]);
    }, []);

    const COLORS = ["#4361EE", "#F3722C", "#4CC9F0", "#A9A9A9"];

    return (
        <div className="dashboard-grid flex-grow-1">
            <div className="grid-item item-1">
                <SummaryBarTile
                    title="Last Month Sales"
                    subtitle="Last 6 month Total Sales"
                    data={salesChanges}
                    highlightColor="#F3722C"
                    baseColor="#CDECE7"
                />
            </div>

            <div className="grid-item item-2">
                <div className="banner-content text-white p-4">
                    <img src={Banner} className="w-100 h-100" />
                </div>
            </div>

            <div className="grid-item item-3">
                <SummaryValueTile
                    title="Walmart Total Sales"
                    total={862636.75}
                    submetrics={[
                        { label: "Units sold" },
                        { label: "Total volume", value: "+0.8% than last month" },
                    ]}
                    trendData={trendData}
                    lineColor="#F3722C"
                />
            </div>

            <div className="grid-item item-4">
                <CategoryOverviewTile
                    title="Soda Category Overview"
                    subtitle="Last Month"
                    data={categoryData}
                />
            </div>

            <div className="grid-item item-5">
                <ComparisonBarTile
                    title="Revenue contribution by KA"
                    data={revenueData}
                    series={[
                        { key: "current", name: "This Year", color: "#F3722C" },
                        { key: "previous", name: "Last Year", color: "#3A0CA3" },
                    ]}
                />
            </div>

            <div className="grid-item item-6">
                <TrendsLineTile
                    title="Sales Trends"
                    subtitle="Monthly comparison"
                    data={salesTrendData}
                    series={[
                        { key: "thisYear", name: "This Year Sales", color: "#F3722C" },
                        { key: "lastYear", name: "Last Year Sales", color: "#3A0CA3" },
                    ]}
                />
            </div>

            <div className="grid-item item-7">
                <SalesEfficiencyTile
                    title="Sales vs Distribution Efficiency"
                    subtitle="By Category"
                    data={efficiencyData}
                />
            </div>
        </div>
    );
};

export default HomeDashboard;
